import { axios } from '../util/axios'
import lastLoginStorage from '../util/lastLoginStorage'
import platform from '../util/platform'
import SmartLock from '../util/smartLock'

const API_ENDPOINT_WITH_2FA = '/2fa/v1/login/pincode'
const API_ENDPOINT_WITH_2FA_VALIDATION = '/2fa/v2/login/pincode'
const API_LOGIN_TURNSTILE_V2 = '/2fa/v2/login/captcha'
const API_SPLIT_LOGIN_CHECK_EMAIL = '/v0/user/login/check_email'
const API_LOGIN_VALIDATION_V4 = '/2fa/v4/login'
const API_LOGIN_FACIAL_RECOGNITION = '/v0/user/login/start/facial-recognition'

const smartLock = new SmartLock('login')

export const loginWith2FA = (code, token, type, sessionTokens, abTests) => {
  if (sessionTokens) sessionTokens.policy_type = 'login-sms_2fa'
  return axios
    .post(
      API_ENDPOINT_WITH_2FA,
      {
        code,
        token,
        type,
        session_ids: sessionTokens,
      },
      {
        headers: {
          'X-TestAB-Groups': abTests,
        },
      }
    )
    .then(async ({ data }) => {
      lastLoginStorage.saveEmailLogin(data)
      return data
    })
}

export const loginWith2FAValidation = (code, token, type) =>
  axios
    .post(
      API_ENDPOINT_WITH_2FA_VALIDATION,
      {
        code,
        token,
        type,
      },
      {
        withCredentials: true,
      }
    )
    .then(async ({ data }) => {
      lastLoginStorage.saveEmailLogin(data)
      return data
    })

export const loginWithTurnstilev2 = (email, password, turnstileToken, sessionTokens, abTests) => {
  if (sessionTokens) sessionTokens.policy_type = 'login-email_password'
  return axios
    .post(
      API_LOGIN_TURNSTILE_V2,
      {
        email: email.toLowerCase().trim(),
        password: password,
        platform: platform,
        session_ids: sessionTokens,
      },
      {
        headers: {
          'X-Accounts-Login-Turnstile': turnstileToken,
          'X-TestAB-Groups': abTests,
        },
        withCredentials: true,
      }
    )
    .then(async ({ data }) => {
      const { fullName = '' } = data
      lastLoginStorage.saveEmailLogin(data)
      await smartLock.saveCredential(email, password, fullName)
      return data
    })
}

export const loginWithFacialRecognition = email =>
  axios.post(
    API_LOGIN_FACIAL_RECOGNITION,
    {
      email: email.toLowerCase().trim(),
    },
    {
      withCredentials: true,
    }
  )

export const loginWithValidation = (email, password, sessionTokens) =>
  axios
    .post(
      API_LOGIN_VALIDATION_V4,
      {
        email: email.toLowerCase().trim(),
        password: password,
        platform: platform,
        session_ids: sessionTokens,
      },
      {
        withCredentials: true,
      }
    )
    .then(async ({ data }) => {
      const { fullName = '' } = data
      lastLoginStorage.saveEmailLogin(data)
      await smartLock.saveCredential(email, password, fullName)
      return data
    })

export const checkMail = email =>
  axios.post(
    API_SPLIT_LOGIN_CHECK_EMAIL,
    {
      email: email.toLowerCase().trim(),
    },
    {
      withCredentials: true,
    }
  )
